export default "__VITE_ASSET__Xk82DGh0__"